<template>
  <div class="ed-acc">
    <header class="ed-acc__h">
      <span class="ed-acc__h-num">CO</span>
      <h3 class="ed-acc__h-title">Gastos</h3>
      <span class="ed-acc__h-rule"></span>
      <span class="ed-acc__h-meta">Distribución por sub-cuenta</span>
    </header>

    <div v-if="!loading">
      <div class="ed-acc__card" v-if="gatos_location.series.length > 0">
        <div class="ed-acc__card-head">
          <p class="ed-acc__eyebrow">Resumen del período</p>
          <h4 class="ed-acc__title">Composición de gastos</h4>
        </div>
        <DonutChart :title_header="''" :data="gatos_location" />
      </div>

      <div v-else class="ed-acc__empty">Sin datos para el período seleccionado.</div>
    </div>
    <div v-else class="ed-acc__sk"></div>
  </div>
</template>

<script>
import DonutChart from "@/components/Charts/DonutChart.vue";

export default {
  components: { DonutChart },
  data() {
    return {
      loading: false,
      gatos_location: { series: [], label: [] },
    };
  },
  props: {
    filter: { type: Object, default: () => ({}) },
  },
  created() { this.getData(); },
  watch: {
    filter: { handler() { this.getData(); }, deep: true },
  },
  methods: {
    async getData() {
      if (!this.filter || !this.filter.business) return;
      this.loading = true;
      try {
        const payload = {
          business: this.filter.business,
          locations: this.filter.location,
          from_date: this.filter.from_date,
          end_date: this.filter.to_date,
          period_id: this.filter.period_id,
        };
        const data = await this.$store.dispatch("dashboard/fetchCached", {
          endpoint: "accounting/get_gastos_dashboard",
          payload,
          fetcher: async () => {
            const r = await this.api_Post("accounting/get_gastos_dashboard", payload);
            return await r.json();
          },
        });
        const label = [], series = [];
        for (const item of (data || [])) {
          label.push(`${item.sub_account_name} / ${this.currencyFormat(parseFloat(item.month_total))}`);
          series.push(parseFloat(item.month_total));
        }
        this.gatos_location = { label, series };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$ink:    #0E1B2C;
$muted:  #8A98AB;
$graph:  #4B5A6B;
$rule:   #D9DEE6;
$rule-soft: #ECEEF2;
$paper-soft: #FBF9F4;
$card:   #FFFFFF;
$brass:  #B68A3E;

$display: 'Fraunces', Georgia, serif;
$sans:    'Inter Tight', sans-serif;
$mono:    'JetBrains Mono', monospace;

.ed-acc { font-family: $sans; color: $ink; display: flex; flex-direction: column; gap: 14px; padding: 12px 0; }
.ed-acc__h { display: flex; align-items: center; gap: 14px; }
.ed-acc__h-num   { font-family: $mono; font-size: 11px; font-weight: 500; color: $brass; letter-spacing: .14em; }
.ed-acc__h-title { font-family: $display; font-style: italic; font-weight: 400; font-size: 22px; letter-spacing: -.01em; color: $ink; margin: 0; }
.ed-acc__h-rule  { flex: 1; height: 1px; background: $rule; }
.ed-acc__h-meta  { font-family: $sans; font-size: 11px; font-weight: 500; color: $muted; letter-spacing: .14em; text-transform: uppercase; }

.ed-acc__card { background: $card; border: 1px solid $rule; padding: 22px; }
.ed-acc__card-head { margin-bottom: 8px; }
.ed-acc__eyebrow { font-family: $sans; font-size: 10px; font-weight: 600; color: $muted; letter-spacing: .22em; text-transform: uppercase; margin: 0 0 4px; }
.ed-acc__title   { font-family: $display; font-size: 20px; letter-spacing: -.01em; color: $ink; margin: 0; }

.ed-acc__empty {
  padding: 60px 0; text-align: center;
  font-family: $display; font-style: italic; color: $muted;
  background: $card; border: 1px solid $rule;
}

.ed-acc__sk {
  height: 360px;
  background: linear-gradient(90deg, $paper-soft 0%, $rule-soft 50%, $paper-soft 100%);
  background-size: 200% 100%; animation: shimmer 1.4s linear infinite;
  border: 1px solid $rule;
}
@keyframes shimmer { 0%{background-position:200% 0;} 100%{background-position:-200% 0;} }

::v-deep .modern-card,
::v-deep .v-card {
  background: transparent !important; border: 0 !important;
  box-shadow: none !important; padding: 0 !important; border-radius: 0 !important;
}
</style>
